// extracted by mini-css-extract-plugin
export default {"hexagon":"RndDHexaCard_hexagon__TWDYi","shape":"RndDHexaCard_shape__wWhCb","icon":"RndDHexaCard_icon__89Tdr","info":"RndDHexaCard_info__mjKxc"};